/* eslint-disable camelcase,max-statements,consistent-return,no-invalid-this */

/**
 * Class Segment
 * @param {string} id - Unique id of the list
 * @param {string} name - Name of the list
 * @param {number} organizer - organizerId
 * @param {string} query - Arguments to retrieve contact by this query
 * @constructor
 */
class Segment {
	constructor({
		id,
		contacts,
		name,
		comment,
		organizer,
		query,
		is_building,
		contacts_list_histogram,
		contacts_age_histogram,
		created,
		archived,
		last_auto_archived,
		structure,
		modified
	} = {}) {
		this._id = id;
		this._contacts = contacts || 0;
		this._name = name;
		this._comment = comment;
		this._organizer = organizer;
		this._query = query || null;
		this._is_building = is_building || false;
		this._contacts_list_histogram = contacts_list_histogram ||[];
		this._contacts_age_histogram = contacts_age_histogram ||{};
		this._created = created;
		this._archived = archived;
		this._last_auto_archived = last_auto_archived || null;
		this._structure = structure || null;
		this._modified = modified;
	}

	getKey() {
		return String(this._id);
	}

	getId() {
		return this._id;
	}

	getContacts() {
		return this._contacts;
	}

	getName() {
		return this._name;
	}

	getComment() {
		return this._comment;
	}

	getOrganizer() {
		return this._organizer;
	}

	getQuery() {
		return this._query;
	}

	getQueryParamsCount() {
		const matches = this.getQuery() ? this.getQuery().match(/[a-z\d]+=[a-z\d]+/gi) : null;

		return matches ? matches.length : 0;
	}

	toString() {
		return this._name;
	}

	isBuilding() {
		return this._is_building;
	}

	getContactsHistogram() {
		return this._contacts_list_histogram;
	}

	getPeriodEntryCount() {
		return this._contacts_list_histogram.reduce(
			(count, { entry }) => count + entry, 0
		);
	}

	getPeriodExitCount() {
		return this._contacts_list_histogram.reduce(
			(count, { exit }) => count + exit, 0
		);
	}

	getPeriodTotalCount() {
		if(!this._contacts_list_histogram[this._contacts_list_histogram.length - 1]) {
			return 0;
		}

		return this._contacts_list_histogram[this._contacts_list_histogram.length - 1]['count'];
	}

	getContactsAgeHistogram() {
		return this._contacts_age_histogram;
	}

	getCreated() {
		return this._created;
	}

	isArchived() {
		return this._archived !== null;
	}

	getStatus() {
		return this._archived !== null ? 'archived' : 'active';
	}

	getStructure() {
		return this._structure;
	}

	isStatic() {
		return this.getQuery() === null;
	}

	isStructure() {
		return this._structure !== null;
	}

	get isAutoArchived() {
		return this._last_auto_archived !== null;
	}

	getModified = () => this._modified;
}

export default Segment;
